"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3853],{

/***/ 63512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25989);
/* harmony import */ var _Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62122);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96098);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${_Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__/* .BREAK_POINTS.xl */ .d.xl}) {
    width: ${(props) => props.fluid ? "100%" : (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(props.maxWidth || "")};
  }
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
`;
const Container = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, { children, fluid = false, maxWidth = 1232 } = _a, others = __objRest(_a, ["children", "fluid", "maxWidth"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    maxWidth,
    fluid,
    ref
  }, others), children);
});
Container.displayName = "Container";




/***/ }),

/***/ 58519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JX": function() { return /* binding */ Col; },
/* harmony export */   "XE": function() { return /* binding */ floorPercentage; },
/* harmony export */   "e9": function() { return /* binding */ percentage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67085);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _RowContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43443);
/* harmony import */ var _constant_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62122);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25989);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75537);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21483);








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function parseFlex(flex) {
  if (typeof flex === "number") {
    return `${flex} ${flex} auto`;
  }
  if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) {
    return `0 0 ${flex}`;
  }
  return flex;
}
const sizes = ["xs", "sm", "md", "lg", "xl", "xxl"];
const Col = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const { gutter, wrap } = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_RowContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
  const _a = props, {
    span,
    order,
    offset,
    push,
    pull,
    className,
    children,
    flex,
    style
  } = _a, others = __objRest(_a, [
    "span",
    "order",
    "offset",
    "push",
    "pull",
    "className",
    "children",
    "flex",
    "style"
  ]);
  const prefixCls = "teko-col";
  let sizeClassObj = {};
  sizes.forEach((size) => {
    let sizeProps = {};
    const propSize = props[size];
    if (typeof propSize === "number") {
      sizeProps.span = propSize;
    } else if (typeof propSize === "object") {
      sizeProps = propSize || {};
    }
    sizeClassObj = __spreadProps(__spreadValues({}, sizeClassObj), {
      [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== void 0,
      [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
      [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
      [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
      [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0
    });
  });
  const classes = classnames__WEBPACK_IMPORTED_MODULE_1___default()(prefixCls, {
    [`${prefixCls}-${span}`]: span !== void 0,
    [`${prefixCls}-order-${order}`]: order,
    [`${prefixCls}-offset-${offset}`]: offset,
    [`${prefixCls}-push-${push}`]: push,
    [`${prefixCls}-pull-${pull}`]: pull
  }, className, sizeClassObj);
  let mergedStyle = __spreadValues({}, style);
  if (gutter) {
    mergedStyle = __spreadValues(__spreadValues({}, gutter[0] && gutter[0] > 0 ? {
      paddingLeft: gutter[0] / 2,
      paddingRight: gutter[0] / 2
    } : {}), mergedStyle);
  }
  if (flex) {
    mergedStyle.flex = parseFlex(flex);
    if (flex === "auto" && wrap === false && !mergedStyle.minWidth) {
      mergedStyle.minWidth = 0;
    }
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCol, __spreadProps(__spreadValues({}, others), {
    style: mergedStyle,
    className: classes,
    ref
  }), children);
});
Col.displayName = "Col";
const floorPercentage = (percent) => {
  return Math.floor(percent * 100) / 100;
};
const percentage = (x, y) => {
  return floorPercentage(x / y * 100) + "%";
};
const loopGridColumn = (_class = "") => {
  let _css = `
    &.teko-col${_class}-0 {
      display: none;
    }
    &.teko-col-push-0 {
      left: auto;
    }
    &.teko-col-pull-0 {
      right: auto;
    }
    &.teko-col${_class}-push-0 {
      left: auto;
    }
    &.teko-col${_class}-pull-0 {
      right: auto;
    }
    &.teko-col${_class}-offset-0 {
      margin-left: 0;
    }
    &.teko-col${_class}-order-0 {
      order: 0;
    }
  `;
  for (let i = 0.5; i <= 24; i += 0.5) {
    _css += `
      &.teko-col${_class}-${String(i).replace(".", "\\.")} {
        display: block;
        flex: 0 0 ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .GRID_COLUMNS */ .s)};
        max-width: ${_class === "-lg" ? "84px" : ["-xl", "-xxl"].includes(_class) ? "104px" : percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-push-${i} {
        left: ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-pull-${i} {
        right: ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-offset-${i} {
        margin-left: ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-order-${i} {
        order: ${i};
      }
    `;
  }
  return _css;
};
const makeGrid = _emotion_react__WEBPACK_IMPORTED_MODULE_5__.css`
  ${loopGridColumn()}
  ${loopGridColumn("-xs")}
  ${Object.keys(_constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .BREAK_POINTS */ .d).map((label) => label !== "xs" ? `
    @media (min-width: ${_constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .BREAK_POINTS */ .d[label]}) {
      ${loopGridColumn(`-${label}`)}
    }
  ` : "").join("")}
`;
const flexStyle = (flex) => {
  if (!flex)
    return;
  return `
    flex: ${parseFlex(flex)};
    ${typeof flex === "string" ? `max-width: ${flex} !important;` : ""}
  `;
};
const makeFlexStyles = (props) => {
  var _a;
  return _emotion_react__WEBPACK_IMPORTED_MODULE_5__.css`
    ${typeof props.xs === "object" && ((_a = props.xs) == null ? void 0 : _a.flex) !== void 0 ? flexStyle(props.xs.flex) : ""}
    ${Object.keys(_constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .BREAK_POINTS */ .d).map((label) => {
    var _a2, _b;
    return ((_a2 = props[label]) == null ? void 0 : _a2.flex) && label !== "xs" ? `
      @media (min-width: ${_constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .BREAK_POINTS */ .d[label]}) {
        ${flexStyle((_b = props[label]) == null ? void 0 : _b.flex)};
      }
    ` : "";
  }).join("")}
  `;
};
const StyledCol = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div(`
  &.teko-col {
    position: relative;
    max-width: 100%;
    // Prevent columns from collapsing when empty
    min-height: 1px;
  }`, _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_6__/* .CommonStyles */ .F, makeGrid, makeFlexStyles);




/***/ }),

/***/ 49624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ Row; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/cache/classnames-npm-2.3.1-f2ae0a8d3c-14db8889d5.zip/node_modules/classnames/index.js
var classnames = __webpack_require__(67085);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/RowContext.es.js
var RowContext_es = __webpack_require__(43443);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/util.es.js
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const responsiveArray = [
  "xxl",
  "xl",
  "lg",
  "md",
  "sm",
  "xs"
];
const responsiveMap = {
  xs: "(max-width: 575px)",
  sm: "(min-width: 576px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 1024px)",
  xl: "(min-width: 1440px)",
  xxl: "(min-width: 1600px)"
};
const subscribers = /* @__PURE__ */ new Map();
let subUid = -1;
let screens = {};
const responsiveObserve = {
  matchHandlers: {},
  dispatch(pointMap) {
    screens = pointMap;
    subscribers.forEach((func) => func(screens));
    return subscribers.size >= 1;
  },
  subscribe(func) {
    if (!subscribers.size)
      this.register();
    subUid += 1;
    subscribers.set(subUid, func);
    func(screens);
    return subUid;
  },
  unsubscribe(token) {
    subscribers.delete(token);
    if (!subscribers.size)
      this.unregister();
  },
  unregister() {
    Object.keys(responsiveMap).forEach((screen) => {
      const matchMediaQuery = responsiveMap[screen];
      const handler = this.matchHandlers[matchMediaQuery];
      handler == null ? void 0 : handler.mql.removeListener(handler == null ? void 0 : handler.listener);
    });
    subscribers.clear();
  },
  register() {
    Object.keys(responsiveMap).forEach((screen) => {
      const matchMediaQuery = responsiveMap[screen];
      const listener = ({ matches }) => {
        this.dispatch(__spreadProps(__spreadValues({}, screens), {
          [screen]: matches
        }));
      };
      const mql = window.matchMedia(matchMediaQuery);
      mql.addListener(listener);
      this.matchHandlers[matchMediaQuery] = {
        mql,
        listener
      };
      listener(mql);
    });
  }
};
var ResponsiveObserve = responsiveObserve;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/constant.es.js
var constant_es = __webpack_require__(62122);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var index_es = __webpack_require__(25989);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/Row.es.js








var Row_es_defProp = Object.defineProperty;
var Row_es_defProps = Object.defineProperties;
var Row_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Row_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Row_es_hasOwnProp = Object.prototype.hasOwnProperty;
var Row_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var Row_es_defNormalProp = (obj, key, value) => key in obj ? Row_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Row_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Row_es_hasOwnProp.call(b, prop))
      Row_es_defNormalProp(a, prop, b[prop]);
  if (Row_es_getOwnPropSymbols)
    for (var prop of Row_es_getOwnPropSymbols(b)) {
      if (Row_es_propIsEnum.call(b, prop))
        Row_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Row_es_spreadProps = (a, b) => Row_es_defProps(a, Row_es_getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Row_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Row_es_getOwnPropSymbols)
    for (var prop of Row_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Row_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Row = react.forwardRef((props, ref) => {
  const _a = props, {
    justify,
    align,
    className,
    style,
    children,
    gutter = 0,
    wrap
  } = _a, others = __objRest(_a, [
    "justify",
    "align",
    "className",
    "style",
    "children",
    "gutter",
    "wrap"
  ]);
  const [screens, setScreens] = react.useState({
    xs: true,
    sm: true,
    md: true,
    lg: true,
    xl: true,
    xxl: true
  });
  const gutterRef = react.useRef(gutter);
  react.useEffect(() => {
    const token = ResponsiveObserve.subscribe((screen) => {
      const currentGutter = gutterRef.current || 0;
      if (!Array.isArray(currentGutter) && typeof currentGutter === "object" || Array.isArray(currentGutter) && (typeof currentGutter[0] === "object" || typeof currentGutter[1] === "object")) {
        setScreens(screen);
      }
    });
    return () => ResponsiveObserve.unsubscribe(token);
  }, []);
  const getGutter = () => {
    const results = [0, 0];
    const normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
    normalizedGutter.forEach((g, index) => {
      if (typeof g === "object") {
        for (let i = 0; i < responsiveArray.length; i++) {
          const breakpoint = responsiveArray[i];
          if (screens[breakpoint] && g[breakpoint] !== void 0) {
            results[index] = g[breakpoint];
            break;
          }
        }
      } else {
        results[index] = g || 0;
      }
    });
    return results;
  };
  const prefixCls = "teko-row";
  const gutters = getGutter();
  const classes = classnames_default()(prefixCls, {
    [`${prefixCls}-no-wrap`]: wrap === false,
    [`${prefixCls}-${justify}`]: justify,
    [`${prefixCls}-${align}`]: align
  }, className);
  const rowStyle = Row_es_spreadValues(Row_es_spreadValues(Row_es_spreadValues({}, gutters[0] && gutters[0] > 0 ? {
    marginLeft: gutters[0] / -2,
    marginRight: gutters[0] / -2
  } : {}), gutters[1] && gutters[1] > 0 ? {
    rowGap: gutters[1]
  } : {}), style);
  return /* @__PURE__ */ react.createElement(RowContext_es/* default.Provider */.Z.Provider, {
    value: { gutter: gutters, wrap }
  }, /* @__PURE__ */ react.createElement(StyledRow, Row_es_spreadProps(Row_es_spreadValues({}, others), {
    className: classes,
    style: rowStyle,
    ref
  }), children));
});
Row.displayName = "Row";
const StyledRow = emotion_styled_browser_esm["default"].div`
  &.teko-row {
    display: flex;
    flex-flow: row wrap;
  }
  @media (min-width: ${constant_es/* BREAK_POINTS.lg */.d.lg}) {
    &.teko-row {
      justify-content: center;
    }
  }
  &.teko-row:before,
  &.teko-row:after {
    display: flex;
  }

  // No wrap of flex
  &.teko-row-no-wrap {
    flex-wrap: nowrap;
  }

  &.teko-row-start {
    justify-content: flex-start;
  }

  &.teko-row-center {
    justify-content: center;
  }

  &.teko-row-end {
    justify-content: flex-end;
  }

  &.teko-row-space-between {
    justify-content: space-between;
  }

  &.teko-row-space-around {
    justify-content: space-around;
  }

  &.teko-row-top {
    align-items: flex-start;
  }

  &.teko-row-middle {
    align-items: center;
  }
  &.teko-row-baseline {
    align-items: baseline;
  }

  &.teko-row-bottom {
    align-items: flex-end;
  }
  ${index_es/* CommonStyles */.F}
`;




/***/ }),

/***/ 43443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RowContext$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);


const RowContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var RowContext$1 = RowContext;




/***/ }),

/***/ 62122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ BREAK_POINTS; },
/* harmony export */   "s": function() { return /* binding */ GRID_COLUMNS; }
/* harmony export */ });
const BREAK_POINTS = {
  xs: "480px",
  sm: "576px",
  md: "768px",
  lg: "1024px",
  xl: "1440px",
  xxl: "1600px"
};
const GRID_COLUMNS = 12;




/***/ }),

/***/ 66349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BlockHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88384);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63103);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68481);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69168);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div(({
  isMobile,
  theme,
  backgroundColor
}) => `
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${!isMobile ? `
          padding-left: ${theme.spacing.s16};
          padding-right: ${theme.spacing.s16};
          ` : ""}
  height: ${isMobile ? "2.75rem" : "3.5rem"};
  background-color: ${backgroundColor};
`);
const SeeAll = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ theme, color }) => `
    cursor: pointer;
    color: ${theme.colors[color] || theme.colors.textSecondary};
`);
const BlockHeader = ({
  title,
  titleColor,
  link,
  backgroundColor = "unset",
  tracking,
  className,
  style
}) => {
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .useDevice */ .F)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className,
    isMobile,
    backgroundColor,
    style
  }, link ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .CustomLink */ .x, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .Dx, {
    color: titleColor || "textTitle",
    className: "title"
  }, title)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .CustomLink */ .x, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SeeAll, __spreadValues({
    color: link.color || ""
  }, tracking), (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("Xem t\u1EA5t c\u1EA3"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .RightOutlined */ .g, {
    color: link.color
  })))) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .Dx, {
    color: titleColor || "textTitle",
    className: "title"
  }, title));
};




/***/ }),

/***/ 19298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ MegaMenu; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21483);
/* harmony import */ var _MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74010);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92651);
/* harmony import */ var _EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34567);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MegaMenu = ({
  type,
  align = "left",
  menuItems
}) => {
  const [activeMenu, setActiveMenu] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(void 0);
  const verticalMenuWidth = "12.375rem";
  const horizontalMenuHeight = "3rem";
  const megaMenuHeight = "28.5rem";
  if (!menuItems.length)
    return null;
  const hideMenuPanel = () => {
    setActiveMenu(void 0);
  };
  const renderVerticalMegaMenu = () => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MegaMenuWrapper, {
      onMouseLeave: hideMenuPanel
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMegaMenu, {
      className: activeMenu ? "active" : "",
      width: verticalMenuWidth,
      height: megaMenuHeight
    }, menuItems.slice(0, _MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_1__/* .MAX_MENU_ITEMS */ .K).map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadProps(__spreadValues({}, item.link), {
      key: index
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuItem, {
      onMouseEnter: () => {
        setActiveMenu(item);
      }
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuItemImageMegaMenuWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_3__/* .EnhancedImage */ .N, {
      src: item.icon,
      height: "100%"
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Caption */ .YS, {
      level: 2,
      line: 1,
      style: { flex: 1 }
    }, item.name))))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuPanel, {
      className: activeMenu ? "active" : "",
      type,
      verticalMenuWidth,
      menu: menuItems,
      activeMenu,
      onClickMenuItem: hideMenuPanel
    }));
  };
  const renderHorizontalMegaMenu = () => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MegaMenuWrapper, {
      onMouseLeave: hideMenuPanel
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMegaMenu, {
      height: horizontalMenuHeight,
      align
    }, menuItems.slice(0, 14).map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadProps(__spreadValues({}, item.link), {
      key: index
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMenuItem, {
      height: horizontalMenuHeight,
      onMouseEnter: () => {
        setActiveMenu(item);
      }
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
      level: 2,
      line: 1,
      hoverColor: "primary500"
    }, item.name))))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMenuPanel, {
      type,
      className: activeMenu ? "active" : "",
      horizontalMenuHeight,
      menu: menuItems,
      activeMenu,
      onClickMenuItem: hideMenuPanel
    }));
  };
  if (type === "vertical")
    return renderVerticalMegaMenu();
  return renderHorizontalMegaMenu();
};
const MegaMenuWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  position: relative;
`;
const VerticalMenuPanel = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_1__/* .MenuPanel */ .G)(({
  verticalMenuWidth,
  theme
}) => `
  position: absolute;
  top: 0;
  width: calc(75rem - ${verticalMenuWidth});
  left: ${verticalMenuWidth};
  min-height: 100%;
  z-index: 980;
  overflow: hidden;
  transition: all 0.2s;
  visibility: hidden;
  opacity: 0;
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  &.active {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    visibility: visible;
    opacity: 1;
  }
`);
const HorizontalMenuPanel = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_1__/* .MenuPanel */ .G)(({
  horizontalMenuHeight,
  theme
}) => `
  position: absolute;
  left: 0;
  right: 0;
  top: ${horizontalMenuHeight};
  z-index: 980;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s;
  border-bottom-right-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  border-bottom-left-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  &.active {
    visibility: visible;
    opacity: 1;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.05));
  }
`);
const VerticalMegaMenu = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(({ theme, width, height }) => `
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  background-color: ${theme == null ? void 0 : theme.colors.white};
  position: relative;
  overflow: hidden;
  width: ${width};
  height: ${height};
  z-index: 980;
  &.active {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`);
const HorizontalMegaMenu = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(({ theme, height, align }) => `
  height: ${height};
  background-color: ${theme == null ? void 0 : theme.colors.white};
  width: 100%;
  overflow: hidden;
  ${align === "right" ? `display: flex;
        justify-content: flex-end;` : align === "space-between" ? `display: flex;
        justify-content: space-between;` : ""}
`);
const VerticalMenuItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(({ theme }) => `
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: ${theme == null ? void 0 : theme.spacing.s8};
  padding: 0 ${theme == null ? void 0 : theme.spacing.s8};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  overflow: hidden;
  &:hover {
    background-color: ${theme == null ? void 0 : theme.colors.primary50};
    color: ${theme == null ? void 0 : theme.colors.primary500};
  }
`);
const HorizontalMenuItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(({ theme, height }) => `
  padding: 0 ${theme == null ? void 0 : theme.spacing.s12};
  height: ${height};
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  float: left;
  position: relative;
  transition: all 0.3s ease;
  color: ${theme == null ? void 0 : theme.colors.textPrimary};
  &::after {
    content: '';
    height: 2px;
    background-color: ${theme == null ? void 0 : theme.colors.primary500};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    transition: all 0.3s ease;
  }
  &:hover {
    color: ${theme == null ? void 0 : theme.colors.primary500};
    &::after {
      opacity: 1;
    }
  }
`);
const VerticalMenuItemImageMegaMenuWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  width: 22px;
  height: 22px;
`;




/***/ }),

/***/ 74010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ MenuPanel; },
/* harmony export */   "K": function() { return /* binding */ MAX_MENU_ITEMS; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21483);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28247);
/* harmony import */ var _helpers_megaMenu_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41753);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92651);
/* harmony import */ var _EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34567);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MEGA_MENU_BANNER_WIDTH = "14.625rem";
const MAX_MENU_ITEMS = 14;
const MenuPanel = ({
  menu,
  activeMenu,
  className,
  type,
  onClickMenuItem
}) => {
  var _a, _b, _c, _d;
  if (!menu.length)
    return null;
  const col = (item) => {
    return item.map((it, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuLv2, {
      key: it.name + `-${index}`,
      onClick: onClickMenuItem
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadValues({}, it.link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
      level: 1,
      line: 1,
      color: "primary500",
      marginBottom: "s8"
    }, it.name)), it.children.map((subItem, index2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadProps(__spreadValues({}, subItem.link), {
      key: index2
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, subItem.name)))));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuPanelWrapper, {
    isDisplay: !!activeMenu && (!!((_a = activeMenu.banner) == null ? void 0 : _a.src) || !!((_b = activeMenu.children) == null ? void 0 : _b.length)),
    className
  }, menu.slice(0, MAX_MENU_ITEMS).map((menuItem, index) => {
    const getMenuColumns = () => {
      var _a2;
      let totalCols = 6;
      if (type === "vertical")
        totalCols--;
      if ((_a2 = menuItem == null ? void 0 : menuItem.banner) == null ? void 0 : _a2.src)
        totalCols--;
      return totalCols;
    };
    const newMenu = (0,_helpers_megaMenu_es_js__WEBPACK_IMPORTED_MODULE_3__/* .convertMegaMenu */ .R)(menuItem, getMenuColumns());
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuItemsWrapper, __spreadValues({
      key: index,
      isActive: menuItem === activeMenu
    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
      regionName: "megaMenuText",
      isTrackContent: true
    })), newMenu.map((menu2, index2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Column, {
      key: index2
    }, col(menu2.column))));
  }), ((_c = activeMenu == null ? void 0 : activeMenu.banner) == null ? void 0 : _c.src) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadValues({}, (_d = activeMenu.banner) == null ? void 0 : _d.link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_5__/* .EnhancedImage */ .N, {
    src: activeMenu.banner.src,
    width: MEGA_MENU_BANNER_WIDTH,
    height: "100%",
    googleImageParams: {
      width: 400
    },
    tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
      regionName: "megaMenuBanner",
      isTrackContent: true
    })
  })));
};
const Text = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div(({ theme }) => `
  color: ${theme == null ? void 0 : theme.colors.textPrimary};
  margin-bottom: 4px;
  &:hover {
    color: ${theme == null ? void 0 : theme.colors.primary500};
  }
`);
const MenuPanelWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div(({ theme, isDisplay }) => `
  background-color: ${theme == null ? void 0 : theme.colors.white};
  display: ${isDisplay ? "flex" : "none"};
`);
const MenuItemsWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div(({ theme, isActive }) => `
  display: ${isActive ? "flex" : "none"};
  flex: 1;
  padding: ${theme == null ? void 0 : theme.spacing.s12};
`);
const MenuLv2 = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div`
  margin-bottom: 1.5rem;
`;
const Column = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div`
  width: 25%;
  padding: 0 8px;
`;




/***/ }),

/***/ 41753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ convertMegaMenu; }
/* harmony export */ });
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const convertMegaMenu = (menu, numberCol) => {
  if (numberCol < 1)
    return [];
  const newArr = menu.children.map((m) => {
    return {
      len: m.children.length + 1,
      column: [__spreadValues({}, m)]
    };
  });
  if (newArr.length <= numberCol)
    return newArr;
  newArr.sort((a, b) => b.len - a.len);
  const result = [...newArr.slice(0, numberCol)];
  let min;
  let k;
  for (let i = numberCol; i < newArr.length; i++) {
    min = result[0].len;
    k = 0;
    for (let j = 0; j < numberCol; j++) {
      if (min > result[j].len) {
        min = result[j].len;
        k = j;
      }
    }
    result[k] = {
      len: result[k].len + newArr[i].len,
      column: [...result[k].column, ...newArr[i].column]
    };
  }
  return result;
};




/***/ }),

/***/ 39950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useHomePage; },
/* harmony export */   "O": function() { return /* binding */ useMobileDefaultHomePage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97441);
/* harmony import */ var _useDiscovery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30468);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28247);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93859);
/* harmony import */ var _teko_discovery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89172);






const trackDiffBlocks = (clientBlocks, serverBlocks)=>{
    // This statement is used to track block mismatches between client and server
    if ((clientBlocks === null || clientBlocks === void 0 ? void 0 : clientBlocks.length) && (serverBlocks === null || serverBlocks === void 0 ? void 0 : serverBlocks.length)) {
        const clientBlocksIdMap = new Set(clientBlocks.map((param)=>{
            let { id  } = param;
            return id;
        }));
        const serverBlocksIdMap = new Set(serverBlocks.map((param)=>{
            let { id  } = param;
            return id;
        }));
        const trackBlocks = ()=>{
            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_1__/* .trackCustomEvent */ .I)("homeBlocksDiff", {
                label: JSON.stringify({
                    serverBlocks: Array.from(serverBlocksIdMap),
                    clientBlocks: Array.from(clientBlocksIdMap)
                })
            });
        };
        if (clientBlocksIdMap.size !== serverBlocksIdMap.size) {
            trackBlocks();
        } else {
            for (const id of serverBlocksIdMap){
                if (!clientBlocksIdMap.has(id)) {
                    trackBlocks();
                    break;
                }
            }
        }
    }
};
const useHomePage = (serverBlocks)=>{
    const { result: personalizedHomePage  } = (0,_useDiscovery__WEBPACK_IMPORTED_MODULE_2__/* .usePersonalizeBlocks */ .yz)({
        pageTypeEnum: _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .PageTypeEnum.HOME */ .DZ.HOME
    });
    const blocks = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        if (personalizedHomePage === null || personalizedHomePage === void 0 ? void 0 : personalizedHomePage.length) {
            return personalizedHomePage;
        }
        return serverBlocks;
    }, [
        personalizedHomePage
    ]);
    const slideBanners = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const banner = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.WIDE_THICK_BANNER */ .kH.WIDE_THICK_BANNER, blocks);
        if (banner) {
            return (banner === null || banner === void 0 ? void 0 : banner.cookedData) || [];
        }
        return [];
    }, [
        blocks
    ]);
    const topRightBanners = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const banner = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.VERTICAL_2_BANNER */ .kH.VERTICAL_2_BANNER, blocks);
        if (banner) {
            return (banner === null || banner === void 0 ? void 0 : banner.cookedData) || [];
        }
        return [];
    }, [
        blocks
    ]);
    const popupBanner = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        return (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.POPUP_BANNER */ .kH.POPUP_BANNER, blocks);
    }, [
        blocks
    ]);
    const horizontalFourBanners = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        var ref;
        return ((ref = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.HORIZONTAL_4_BANNER */ .kH.HORIZONTAL_4_BANNER, blocks)) === null || ref === void 0 ? void 0 : ref.cookedData) || [];
    }, [
        blocks
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        function trackDiff(deadline) {
            if (deadline.timeRemaining() > 5 || deadline.didTimeout) {
                trackDiffBlocks(personalizedHomePage, serverBlocks);
            } else {
                (0,_teko_utils__WEBPACK_IMPORTED_MODULE_5__/* .requestIdleCallback */ .Kk)(trackDiff);
            }
        }
        (0,_teko_utils__WEBPACK_IMPORTED_MODULE_5__/* .requestIdleCallback */ .Kk)(trackDiff);
    }, [
        personalizedHomePage,
        serverBlocks
    ]);
    return {
        slideBanners,
        topRightBanners,
        blocks,
        popupBanner,
        horizontalFourBanners
    };
};
const useMobileDefaultHomePage = (serverBlocks)=>{
    const { result: personalizedHomePage , isLoading: loadingHomePage  } = (0,_useDiscovery__WEBPACK_IMPORTED_MODULE_2__/* .usePersonalizeBlocks */ .yz)({
        pageTypeEnum: _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .PageTypeEnum.HOME */ .DZ.HOME
    });
    const blocks = (personalizedHomePage === null || personalizedHomePage === void 0 ? void 0 : personalizedHomePage.length) ? personalizedHomePage : serverBlocks;
    const loading = !serverBlocks && loadingHomePage;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        function trackDiff(deadline) {
            if (deadline.timeRemaining() > 5 || deadline.didTimeout) {
                trackDiffBlocks(personalizedHomePage, serverBlocks);
            } else {
                (0,_teko_utils__WEBPACK_IMPORTED_MODULE_5__/* .requestIdleCallback */ .Kk)(trackDiff);
            }
        }
        (0,_teko_utils__WEBPACK_IMPORTED_MODULE_5__/* .requestIdleCallback */ .Kk)(trackDiff);
    }, [
        personalizedHomePage,
        serverBlocks
    ]);
    return {
        blocks,
        loading
    };
};


/***/ }),

/***/ 82257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ AboveTheFold; }
});

// UNUSED EXPORTS: renderMegaMenu

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(49624);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(63512);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(58519);
;// CONCATENATED MODULE: ./modules/home/desktop/components/Next.svg
/* harmony default export */ var Next = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC4zIiBkPSJNMCAyNEMwIDEwLjc0NTIgMTAuNzQ1MiAwIDI0IDBINDhWNDhIMjRDMTAuNzQ1MiA0OCAwIDM3LjI1NDggMCAyNFoiIGZpbGw9IiMxQjFEMjkiLz4KPHBhdGggZD0iTTIxLjUgMzBMMjcuNSAyNEwyMS41IDE4IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=");
;// CONCATENATED MODULE: ./modules/home/desktop/components/Previous.svg
/* harmony default export */ var Previous = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC4zIiBkPSJNMCAwSDI0QzM3LjI1NDggMCA0OCAxMC43NDUyIDQ4IDI0QzQ4IDM3LjI1NDggMzcuMjU0OCA0OCAyNCA0OEgwVjBaIiBmaWxsPSIjMUIxRDI5Ii8+CjxwYXRoIGQ9Ik0yNi41IDE4TDIwLjUgMjRMMjYuNSAzMCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K");
// EXTERNAL MODULE: ./components/desktop/organisms/BannerSlides.tsx
var BannerSlides = __webpack_require__(39559);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/MegaMenu/MegaMenu.es.js
var MegaMenu_es = __webpack_require__(19298);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(28247);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./modules/home/desktop/components/AboveTheFold.tsx
/* eslint-disable @typescript-eslint/ban-ts-comment */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  content-visibility: auto;\n  margin-bottom: 24px;\n  .swiper-pagination {\n    bottom: 6rem !important;\n  }\n  min-height: 600px;\n  @media screen and (max-width: ",
        "px) {\n    height: auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  z-index: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: -72px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









const EnhancedImage = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(1668), __webpack_require__.e(358), __webpack_require__.e(3667), __webpack_require__.e(9456), __webpack_require__.e(1592), __webpack_require__.e(1633), __webpack_require__.e(6329), __webpack_require__.e(9781), __webpack_require__.e(9254), __webpack_require__.e(5125), __webpack_require__.e(5249), __webpack_require__.e(7506), __webpack_require__.e(3835), __webpack_require__.e(9302), __webpack_require__.e(3709), __webpack_require__.e(2771), __webpack_require__.e(3738), __webpack_require__.e(1874)]).then(__webpack_require__.bind(__webpack_require__, 13738)).then((mod)=>mod.EnhancedImage), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(13738)
            ]
    }
});
const FeaturedBanners = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(1668), __webpack_require__.e(358), __webpack_require__.e(3667), __webpack_require__.e(9456), __webpack_require__.e(1592), __webpack_require__.e(1633), __webpack_require__.e(6329), __webpack_require__.e(9781), __webpack_require__.e(9254), __webpack_require__.e(5125), __webpack_require__.e(5249), __webpack_require__.e(7506), __webpack_require__.e(3835), __webpack_require__.e(9302), __webpack_require__.e(3709), __webpack_require__.e(2771), __webpack_require__.e(3738), __webpack_require__.e(1874)]).then(__webpack_require__.bind(__webpack_require__, 13738)).then((mod)=>mod.FeaturedBanners), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(13738)
            ]
    }
});
const sliderHeight = 566;
const maxWidth = 767;
const Wrapper = emotion_styled_browser_esm["default"].div(_templateObject(), maxWidth);
Wrapper.displayName = "AboveTheFold";
const StyledBannerSlides = emotion_styled_browser_esm["default"].div(_templateObject1());
const FourBannerWrapper = (0,emotion_styled_browser_esm["default"])(Row_es/* Row */.X)(_templateObject2());
const NavBtnWrapper = emotion_styled_browser_esm["default"].img((param)=>{
    let { show , left , right  } = param;
    return "\n  opacity: ".concat(show ? "1" : "0", ";\n  z-index: 549;\n  cursor: pointer;\n  transition: 0.1s;\n  position: absolute;\n  top: 39.5%;\n  ").concat(left ? "left: ".concat(left, ";") : "", "\n  ").concat(right ? "right: ".concat(right, ";") : "", "\n");
});
const RightBannerWrapper = emotion_styled_browser_esm["default"].div(_templateObject3());
const renderMegaMenu = (menuItems)=>{
    if (!(menuItems === null || menuItems === void 0 ? void 0 : menuItems.length)) return;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_es/* MegaMenu */.V, {
        menuItems: menuItems,
        type: "vertical"
    });
};
const AboveTheFold = (param)=>{
    let { menuItems , slideBanners =[] , topRightBanners =[] , horizontalFourBanners =[]  } = param;
    const sliderRef = (0,react.useRef)(null);
    const { 0: showNavBtns , 1: setShowNavBtns  } = (0,react.useState)(false);
    if (!menuItems.length && !slideBanners.length && !topRightBanners.length) return null;
    const isOnlySlideBanner = !menuItems.length && !topRightBanners.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container_es/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                    justify: "space-around",
                    style: {
                        height: "".concat(sliderHeight, "px")
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col_es/* Col */.JX, {
                            span: 2,
                            paddingTop: "s16",
                            children: [
                                renderMegaMenu(menuItems),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBtnWrapper, {
                                    onMouseEnter: ()=>setShowNavBtns(true),
                                    show: showNavBtns,
                                    right: !isOnlySlideBanner ? "-46px" : undefined,
                                    left: isOnlySlideBanner ? "0" : undefined,
                                    onClick: ()=>{
                                        if (sliderRef.current) {
                                            sliderRef.current.glide.go("<");
                                        }
                                    },
                                    src: Previous,
                                    alt: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                flex: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBannerSlides, {
                                onMouseEnter: ()=>setShowNavBtns(true),
                                onMouseLeave: ()=>setShowNavBtns(false),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSlides/* BannerSlides */.j, {
                                    imageWidth: 1920,
                                    banners: slideBanners,
                                    sliderRef: sliderRef,
                                    prioritized: true
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col_es/* Col */.JX, {
                            span: 2,
                            paddingTop: "s16",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBtnWrapper, {
                                    onMouseEnter: ()=>setShowNavBtns(true),
                                    show: showNavBtns,
                                    onClick: ()=>{
                                        if (sliderRef.current) {
                                            sliderRef.current.glide.go(">");
                                        }
                                    },
                                    left: !isOnlySlideBanner ? "-48px" : undefined,
                                    right: isOnlySlideBanner ? "0" : undefined,
                                    src: Next,
                                    alt: ""
                                }),
                                topRightBanners.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RightBannerWrapper, {
                                    children: topRightBanners.map((banner, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(EnhancedImage, {
                                            link: {
                                                href: banner.targetPath
                                            },
                                            tracking: (0,helper_es/* getTrackingData */.O5)({
                                                isTrackContent: true,
                                                regionName: "topRightBannerHomepage",
                                                contentName: banner.campaignName,
                                                index: index,
                                                target: banner.targetPath
                                            }),
                                            src: banner.image,
                                            borderRadius: 8,
                                            height: 220,
                                            objectFit: "cover",
                                            googleImageParams: {
                                                width: 300
                                            },
                                            hover: "zoom",
                                            alt: banner.campaignName || banner.description || "",
                                            lazy: false,
                                            fetchPriority: "high"
                                        }, index))
                                })
                            ]
                        })
                    ]
                }),
                !!horizontalFourBanners.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(FourBannerWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                        span: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedBanners, {
                            prioritized: true,
                            regionName: "bottomBanner",
                            banners: horizontalFourBanners.map((banner)=>{
                                return {
                                    src: banner.image,
                                    link: {
                                        href: banner.targetPath
                                    },
                                    name: banner.campaignName,
                                    lazy: false
                                };
                            })
                        })
                    })
                })
            ]
        })
    });
};


/***/ })

}]);